// extracted by mini-css-extract-plugin
var _1 = "DObPdXf5mqltja9UbU5D";
var _2 = "fZAM6Dg77j0WCpKPfmUS";
var _3 = "RMPuzdxjoUyTG26_yHvY";
export { _1 as "centered", _2 as "item", _3 as "wrapper" }
